<template>
  <div>
    <div v-show="! previewMode">
      <div
        @mouseenter="showMenu = true"
        @mouseleave="showMenu = false"
      >
        <div v-show="showMenu" class="wf-inline-block wf-pr-2 wf-bg-white wf-rounded-md wf-shadow-md wf-mb-4">
          <ul class="wf-flex">
            <li v-show="properties.alignment">
              <DropdownMenu>
                <template slot="trigger">
                  <span class="wf-inline-block wf-flex wf-items-center wf-justify-center wf-text-gray-400 hover:wf-text-blue-500 wf-h-10 wf-w-10">
                    <i class="fas wf-text-sm" :class="selectedAlignment"></i>
                  </span>
                </template>
                <template slot="menu">
                  <li>
                    <button
                      @click.prevent="addStyle('align', false)"
                      class="wf-flex wf-items-center wf-justify-start hover:wf-text-blue-500 focus:wf-outline-none wf-text-sm wf-px-4 wf-py-2 wf-w-full"
                      :class="(! currentSelectionHasAttribute['align']) && ! currentSelectionHasAttribute('align', 'center') && ! currentSelectionHasAttribute('align', 'right') && ! currentSelectionHasAttribute('align', 'justify') ? ['wf-text-blue-500', 'wf-bg-blue-100'] : []"
                    ><i class="fas wf-text-xs wf-mr-4 fa-align-left"></i> Left</button>
                  </li>
                  <li>
                    <button
                      @click.prevent="addStyle('align','center')"
                      class="wf-flex wf-items-center wf-justify-start hover:wf-text-blue-500 focus:wf-outline-none wf-text-sm wf-px-4 wf-py-2 wf-w-full"
                      :class="currentSelectionHasAttribute('align', 'center') ? ['wf-text-blue-500', 'wf-bg-blue-100'] : []"
                    ><i class="fas wf-text-xs wf-mr-4 fa-align-center"></i> Center</button>
                  </li>
                  <li>
                    <button
                      @click.prevent="addStyle('align', 'right')"
                      class="wf-flex wf-items-center wf-justify-start hover:wf-text-blue-500 focus:wf-outline-none wf-text-sm wf-px-4 wf-py-2 wf-w-full"
                      :class="currentSelectionHasAttribute('align', 'right') ? ['wf-text-blue-500', 'wf-bg-blue-100'] : []"
                    ><i class="fas wf-text-xs wf-mr-4 fa-align-right"></i> Right</button>
                  </li>
                  <li>
                    <button
                      @click.prevent="addStyle('align', 'justify')"
                      class="wf-flex wf-items-center wf-justify-start hover:wf-text-blue-500 focus:wf-outline-none wf-text-sm wf-px-4 wf-py-2 wf-w-full"
                      :class="currentSelectionHasAttribute('align', 'justify') ? ['wf-text-blue-500', 'wf-bg-blue-100'] : []"
                    ><i class="fas wf-text-xs wf-mr-4 fa-align-justify"></i> Justify</button>
                  </li>
                </template>
              </DropdownMenu>
            </li>
            <li v-show="properties.bold">
              <button
                @click.prevent="addStyle('bold', ! currentSelectionAttributes['bold'])"
                :class="currentSelectionHasAttribute('bold') ? ['wf-text-blue-500', 'wf-bg-blue-100'] : ['wf-text-gray-400']"
                class="wf-flex wf-items-center wf-justify-center hover:wf-text-blue-500 wf-h-10 wf-w-10 focus:wf-outline-none"
              ><i class="fas wf-text-sm fa-bold"></i></button>
            </li>
            <li v-show="properties.italic">
              <button
                @click.prevent="addStyle('italic', ! currentSelectionAttributes['italic'])"
                class="wf-flex wf-items-center wf-justify-center hover:wf-text-blue-500 wf-h-10 wf-w-10 focus:wf-outline-none"
                :class="currentSelectionHasAttribute('italic') ? ['wf-text-blue-500', 'wf-bg-blue-100'] : ['wf-text-gray-400']"
              ><i class="fas wf-text-sm fa-italic"></i></button>
            </li>
            <li v-show="properties.underline">
              <button
                @click.prevent="addStyle('underline', ! currentSelectionAttributes['underline'])"
                class="wf-flex wf-items-center wf-justify-center hover:wf-text-blue-500 wf-h-10 wf-w-10 focus:wf-outline-none"
                :class="currentSelectionHasAttribute('underline') ? ['wf-text-blue-500', 'wf-bg-blue-100'] : ['wf-text-gray-400']"
              ><i class="fas wf-text-sm fa-underline"></i></button>
            </li>
            <li v-show="properties.strike">
              <button
                @click.prevent="addStyle('strike', ! currentSelectionAttributes['strike'])"
                class="wf-flex wf-items-center wf-justify-center hover:wf-text-blue-500 wf-h-10 wf-w-10 focus:wf-outline-none"
                :class="currentSelectionHasAttribute('strike') ? ['wf-text-blue-500', 'wf-bg-blue-100'] : ['wf-text-gray-400']"
              ><i class="fas wf-text-sm fa-strikethrough"></i></button>
            </li>
            <li v-show="properties.link">
              <button
                @click.prevent="! currentSelectionAttributes['link'] ? openLinkModal() : addStyle('link', false)"
                class="wf-flex wf-items-center wf-justify-center hover:wf-text-blue-500 wf-h-10 wf-w-10 focus:wf-outline-none"
                :class="currentSelectionAttributes['link'] ? ['wf-text-blue-500', 'wf-bg-blue-100'] : ['wf-text-gray-400']"
              ><i class="fas wf-text-sm" :class="! currentSelectionAttributes['link'] ? 'fa-link' : 'fa-unlink'"></i></button>
            </li>
            <li v-show="properties.color" class="wf-relative wf-flex wf-items-center wf-ml-2 wf-justify-center">
              <EditorPicker
                pickerContainerClasses="wf-h-6 wf-w-6"
                pickerClasses="wf-top-0 wf-mt-8 wf-right-0"
                :value="currentSelectionAttributes['color'] ? currentSelectionAttributes['color'] : '#000000'"
                @input="updateColor"
              />
            </li>
            <li v-show="properties.header" class="wf-flex wf-items-center wf-ml-2">
              <select
                @change="updateHeader"
                class="wf-h-8 wf-text-gray-600 wf-lowercase wf-tracking-wide wf-text-sm wf-w-32"
                :value="currentSelectionAttributes['header'] ? currentSelectionAttributes['header'] : false"
              >
                <option value="1">Header 1</option>
                <option value="2">Header 2</option>
                <option value="3">Header 3</option>
                <option :value="false">paragraph</option>
              </select>
            </li>
            <li v-show="properties.size" class="wf-ml-4 wf-flex wf-items-center">
              <select
                @change="updateSize"
                :value="currentSelectionAttributes['size'] ? currentSelectionAttributes['size'] : false"
                class="wf-h-8 wf-text-gray-600 wf-lowercase wf-tracking-wide wf-text-sm wf-w-32"
              >
                <option value="xs">Small</option>
                <option :value="false">Normal</option>
                <option value="xl">Large</option>
                <option value="3xl">Huge</option>
              </select>
            </li>
          </ul>
        </div>
        <div
          :class="containerClasses"
          ref="quillEditor"
          :value="value"
          v-html="placeholder"
          @input="updateContent"
        ></div>  
      </div>
      <EditorLinkModal @linkSaved="addLink"/>
    </div>
    <div v-show="previewMode" v-html="value"></div>
    </div>
</template>

<script>
  import EditorLinkModal from './EditorLinkModal'
  import EditorPicker from './EditorPicker'
  import Quill from 'quill'
  export default {
    props: {
      allowNewRow: {
        type: Boolean,
        required: false,
        default: false
      },
      styles: {
        type: Object,
        required: false,
        default: () => ({})
      },
      showProperties: {
        type: Array,
        required: false,
      },
      containerClasses: {
        type: [String, Array],
        required: false,
        default: () => []
      },
      value: {
        type: [String],
        required: true
      },
    },
    components: { EditorLinkModal, EditorPicker },
    data() {
      return {
        placeholder: 'This is a placeholder',
        showMenu: false,
        currentSelectionRange: null,
        currentSelectionAttributes: {},
        editor: null
      }
    },
    created() {
      this.placeholder = this.value
    },
    mounted() {
      this.initEditor()
      this.setStyles()
    },
    computed: {
      html() {
        if (! this.editor) {
          return ''
        }
        return this.editor.root.innerHTML
      },
      previewMode() {
        return this.$store.state.previewMode
      },
      properties() {
        let properties = {
          alignment: true,
          bold: true,
          italic: true,
          underline: true,
          strike: true,
          link: true,
          color: true,
          header: true,
          size: true,
        }
        let newProperties = {}
        if(! this.showProperties) {
          return properties
        }
        this.showProperties.forEach(property => this.$set(newProperties, property, true))
        return newProperties
      },
      selectedAlignment() {
        if (this.currentSelectionAttributes['align'] == 'center') {
          return 'fa-align-center'
        }
        if (this.currentSelectionAttributes['align'] == 'right') {
          return 'fa-align-right'
        }
        if (this.currentSelectionAttributes['align'] == 'justify') {
          return 'fa-align-justify'
        }
        return 'fa-align-left'
      }
    },
    methods: {
      setStyles() {
        this.editor.setSelection(0, this.editor.getLength())
        Object.keys(this.styles).forEach(style => this.addStyle(style, this.styles[style]))
        this.updateContent()
      },
      updateColor(event) {
        this.addStyle('color', event.hex)
        this.updateContent()
      },
      openLinkModal() {
        this.$modal.show('linkModal')
      },
      addLink(event) {
        this.editor.format('link', event)
        this.editor.format('underline', true)
        this.updateContent()
      },
      initLinkFormat() {
        let Inline = Quill.import('blots/inline');
        let linkBlot = class LinkBlot extends Inline {
          static create(value) {
            let node = super.create()
            node.setAttribute('href', value.link)
            value.blank ? node.setAttribute('target', '_blank') : null
            return node
          }

          static formats(node) {
            return node.getAttribute('href');
          }
        }
        linkBlot.blotName = 'link';
        linkBlot.tagName = 'a';
        return linkBlot
      },
      initSizeFormat() {
        let Size = Quill.import('formats/size')
        Size.keyName = 'wf-text'
        Size.whitelist = ['3xl', 'xl', 'xs']
        return Size
      },
      initAlignFormat() {
        let Align = Quill.import('formats/align')
        Align.keyName = 'wf-text'
        return Align
      },
      initEditor() {
        Quill.register(this.initSizeFormat())
        Quill.register(this.initAlignFormat())
        Quill.register(this.initLinkFormat())
        let options = {}
        if (! this.allowNewRow) {
          options = {
            modules: {
              keyboard: {
                bindings: {
                  handleEnter: {
                    key: 13,
                    handler: () => ({})
                  }
                }
              }
            }
          }
        }
        this.editor = new Quill(this.$refs.quillEditor, options)
        this.editor.on('text-change', this.updateContent)
        this.editor.on('selection-change', event => {
          if (! event) {
            return
          }
          this.setCurrentSelection()
        })
      },
      setCurrentSelection() {
        this.currentSelectionRange = this.editor.getSelection(true)
        this.currentSelectionAttributes = this.editor.getFormat(this.currentSelectionRange)
      },
      addStyle(format, value) {
        this.editor.format(format, value)
      },
      currentSelectionHasAttribute(attribute, value = true) {
        return this.currentSelectionAttributes[attribute] == value
      },
      updateContent() {
        this.setCurrentSelection()
        this.$emit('input', this.editor.root.innerHTML)
      },
      updateHeader(event) {
        this.editor.format('header', JSON.parse(event.srcElement.value))
        this.updateContent()
      },
      updateSize(event) {
        let value = event.srcElement.value == 'false' ? false : event.srcElement.value
        this.editor.formatText(this.currentSelectionRange, 'size', value)
        this.updateContent()
      }
    }
  }
</script>

<style>
  /*ol li {
    list-style-type: upper-roman;
    padding-left: 1rem;
    padding-top: 1rem;
    list-style-position: inside;
  }
  ul li {
    list-style-type: square;
    padding-left: 1rem;
    padding-top: 1rem;
    list-style-position: inside;
  }*/
  .ql-clipboard {
    left: -100000px;
    height: 1px;
    overflow-y: hidden;
    position: absolute;
    top: 50%;
  }

  .ql-editor {
    cursor: text;
    line-height: 1.42;
    height: 100%;
    outline: none;
    overflow-y: auto;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
</style>